{
  "useFakeValidations": {
    "compatibilityView": {
      "compatibility": false
    },
    "numberVerificationView": {
      "otp": false
    },
    "identityVerificationView": {
      "incode": true
    },
    "formDataView": {
      "zipCode": false,
      "simValidation": false,
      "saveData": false
    },
    "creditHistoryView": {
      "credit": false
    },
    "planCardView": {},
    "contractView": {
      "contract": false,
      "sign": false,
      "noPayment": false,
      "portability": false
    }
  }
}
